import * as React from "react";
const DownRed = (props) => (
  <svg
    width={15}
    height={15}
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.9951 6.37764L14.7578 7.12086C15.0807 7.43555 15.0807 7.94443 14.7578 8.25577L8.08234 14.764C7.75939 15.0787 7.23717 15.0787 6.91766 14.764L0.242212 8.25912C-0.0807381 7.94443 -0.0807381 7.43555 0.242212 7.1242L1.00492 6.38098C1.33131 6.06294 1.86383 6.06963 2.18335 6.39438L6.12403 10.4252V0.803481C6.12403 0.358218 6.49164 -9.53674e-07 6.94858 -9.53674e-07H8.04798C8.50492 -9.53674e-07 8.87254 0.358218 8.87254 0.803481V10.4252L12.8167 6.39103C13.1362 6.06294 13.6687 6.05624 13.9951 6.37764Z"
      fill="#FB0606"
    />
  </svg>
);
export default DownRed;
